import InputWrapper from "../../../../components/input/wrapper/InputWrapper";
import OverlayLoader from "../../../../components/loader/OverlayLoader/OverlayLoader";
import { useLanguageContext } from "../../../../context/LanguageContext";
import { StyledInput } from "../../../../styles/InputStyles";
import FormContainer from "../../../../components/formContainer/FormContainer";
import EVAApiHelper from "../../../../helpers/EVAApiHelper";
import { StyledFlexColumn } from "../../../../styles/LayoutStyles";
import TimezoneSelect from "../../../../components/select/custom/timezone/TimezoneSelect";

function LocationPageView({
  locationData,
  onNameChange,
  onAddressChange,
  onTimezoneChange,
  onCancel,
  onSubmit,
  submitError,
}) {
  const { translate } = useLanguageContext();

  return (
    <OverlayLoader groups="location_page_fetch">
      <FormContainer
        onCancel={onCancel}
        onSubmit={onSubmit}
        submitError={submitError}
        submitLoadingGroup={"location_page_save"}
      >
        <StyledFlexColumn>
          <InputWrapper
            label={translate("eva.main.validation.attributes.name")}
            error={EVAApiHelper.getResponseError("name", submitError)}
            required
          >
            <StyledInput
              type="text"
              placeholder={translate("eva.main.validation.attributes.name")}
              value={locationData.name}
              onChange={onNameChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.address")}
            error={EVAApiHelper.getResponseError("address", submitError)}
          >
            <StyledInput
              type="text"
              placeholder={translate("eva.main.validation.attributes.address")}
              value={locationData.address}
              onChange={onAddressChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.timezone")}
            error={EVAApiHelper.getResponseError("timezone", submitError)}
          >
            <TimezoneSelect
              value={locationData.timezone}
              onChange={onTimezoneChange}
              nullable={true}
              placeholder={translate("eva.main.company.timezone.inherit")}
            />
          </InputWrapper>
        </StyledFlexColumn>
      </FormContainer>
    </OverlayLoader>
  );
}

export default LocationPageView;
